module.exports = __webpack_public_path__ + "static/media/intro_6.04ee72f2.png";